<template>
  <v-container fluid class="main-background text-center pt-0">
        <img :src="require('../assets/Eurooil_logo.svg')" class="custom-logo" alt="Čepro logo" itemprop="logo">
        <v-container class="text-center main-title">
            <h1 class="section-title large-heading primary--text font-weight-light d-inline-flex">DEOK</h1>
            <p class="section-title small-heading primary--text mt-5">Získejte kartu a využívejte benefity a slevy</p>
        </v-container>
  </v-container>
</template>

<script>
  export default {
    name: 'HeroBanner',

    data: () => ({
        options: {
            offset: 140,
        }
    }),
      methods: {
          scrollTo: function(target) {
              this.$vuetify.goTo(target, this.options)
          }
      }
  }
</script>

<style lang="scss">
  .main-background {
      img {
          width: 100px;
      }
      .main-title {
          padding-top: 150px;
          @media #{$pixel-less-phone} {
              padding-top: 50px;
          }
      }
        background-image: url(../assets/background/headerbanner-min-small-min.jpg);
        background-position: center center;
        background-repeat: no-repeat;
        background-size: cover;

          .divider {
              background: #f6f9f966;
              @media #{$pixel-less-phone} {
                  margin: auto;
              }
          }
        .section-title {
            color: #FFFFFF;
            &.small-heading {
                font-size: 20px;
                margin-bottom: 20px;
                @media #{$pixel-less-phone} {
                    font-size: 17px;
                }
            }
            &.large-heading {
                font-size: 60px;
                line-height: 1.2;
                border-bottom: 2px solid #0070af;
            }
        }
      h3 {
          margin: 20px 0;
          font-size: 40px;
      }
  }
</style>